export default "__VITE_ASSET__732b291e__"